import React, { useEffect, useState } from "react";
import closeIcon from "../../../assets/icons/close.svg";
import { Modal } from "antd";
import "./addReferenceContent.scss";
import { RouteComponentProps, withRouter } from "react-router";
import ContentLibraryService from "../../../services/ContentLibraryService/contentLibrary.service";
import SelectContent from "../../../views/CourseStructure/Chapters/AddContent/SelectContent";
import ButtonComponent from "../ButtonComponent";
import { ContentLibraryModel } from "../../../models/ContentLibraryModel/contentLibrary.model";
interface AddContentProps extends RouteComponentProps {
  visible: any;
  setVisible: Function;
  onClickAdd: (contents: ContentLibraryModel[]) => void;
}

const AddContent = (props: AddContentProps) => {
  const { visible, setVisible, onClickAdd } = props;

  useEffect(() => {
    fetchContentList();
    setUrlParams(props.match.params);
  }, []);

  const fetchContentList = (searchString?: string) => {
    let queryParam = `?search=${searchString || ""}`;

    ContentLibraryService.getContentLibraryList(
      queryParam,
      (contentLibrary: any) => {
        setContents(contentLibrary);
      },
      () => {},
      () => {}
    ).then();
  };

  const handleSearch = (value: string) => {
    fetchContentList(value);
  };

  const [contents, setContents] = useState<any>([]);
  const [selectedContents, setSelectedContents] = useState<any>([]);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [urlParams, setUrlParams] = useState<any>();

  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      className="board-form__modal add-content__modal"
      closeIcon={<img src={closeIcon} alt="" />}
    >
      <div className="board-form__title add-content-modal__title">
        Add Reference Content
      </div>

        <SelectContent
          handleSearch={handleSearch}
          contentList={contents}
          setSelectedContents={setSelectedContents}
          selectedContents={selectedContents}
        />
      <div className="board-form__action">
        <div
          className="board-form__button"
          onClick={() => {
            setVisible(false);
            setSelectedContents([]);
          }}
        >
          <ButtonComponent buttonContent="Cancel" type="text" />
        </div>
        <div className="board-form__button">
          <ButtonComponent
            buttonContent={"Add"}
            type="primary"
            htmlType="submit"
            loading={buttonLoading}
            onClick={() => {
                setVisible(false)
                onClickAdd(selectedContents)}}
          />
        </div>
      </div>
    </Modal>
  );
};

export default withRouter(AddContent);
